import styled, { css } from 'styled-components';
import Box from 'ui/Box';
import media from 'ui/media';
import ArrowLeftIcon from './icons/arrow_left.svg?react';
import ArrowRightIcon from './icons/arrow_right.svg?react';

export const Wrapper = styled(Box)`
  position: relative;
  display: inline-block;
`;

export const rightIconStyles = css`
  width: ${({ theme }) => theme.space.md};
  cursor: pointer;
`;

export const StyledRightArrowIcon = styled(ArrowRightIcon)`
  ${rightIconStyles}
`;

export const StyledLeftArrowIcon = styled(ArrowLeftIcon)`
  ${rightIconStyles}
`;

export const MenuButton = styled.div`
  pointer-events: auto;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space.xl} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[200]};
  cursor: pointer;
  ${media.mobile`
  padding: 1.6rem 0;
`}
    :last-child {
    border-bottom: none;
  }
`;

export const KompisWrapper = styled.div`
  padding: ${({ theme }) => theme.space.xl} 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[200]};
  ${media.mobile`
  padding: 1.6rem 0;
`}
`;

export const HomeDeliveryWrapper = styled.div`
  padding: ${({ theme }) => theme.space.md} 0;
`;

export const IconWrapper = styled.div`
  kompis-icon {
    pointer-events: auto;
  }
`;

export const LoginWrapper = styled(Box)`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;
